<script setup lang="ts">
definePageMeta({
  isPublic: true,
})

const { t } = useI18n({
  useScope: 'local',
})

usePageTitle(computed(() => t('pageTitle')))
</script>

<template>
  <div>
    <PageTitle :description="t('description')">
      {{ t('pageTitle') }}
    </PageTitle>
    <ActivitySearch />
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "pageTitle": "Activities",
    "description": "Here you can find an overview of local and regional activities where you can participate."
  },
  "nl": {
    "pageTitle": "Activiteitenkalender",
    "description": "Hier vind je een overzicht van lokale en regionale activiteiten waar je aan mee kunt doen."
  }
}
</i18n>
